import type { PhotoDuoArrangement } from './PhotoDuo.types';

const ASPECT_RATIO = {
  primary: '7/5',
  secondary: '5/7',
};
const SCREEN_PROPORTION = {
  primary: '66.66%',
  secondary: '33.33%',
};
const SCREEN_PARTITION = {
  primary: 2 / 3,
  secondary: 1 / 3,
};

export const getAspectRatio = (arrangement: PhotoDuoArrangement, index: number) => {
  if (arrangement === 'left') {
    return index === 0 ? ASPECT_RATIO.primary : ASPECT_RATIO.secondary;
  }
  return index === 0 ? ASPECT_RATIO.secondary : ASPECT_RATIO.primary;
};

export const getGridTemplateColumns = (arrangement: PhotoDuoArrangement) => {
  return arrangement === 'left' ? `${SCREEN_PROPORTION.primary} ${SCREEN_PROPORTION.secondary}` : `${SCREEN_PROPORTION.secondary} ${SCREEN_PROPORTION.primary}`;
};

export const getScreenPartition = (arrangement: PhotoDuoArrangement, index: number) => {
  if (arrangement === 'left') {
    return index === 0 ? SCREEN_PARTITION.primary : SCREEN_PARTITION.secondary;
  }
  return index === 0 ? SCREEN_PARTITION.secondary : SCREEN_PARTITION.primary;
};
